import {formatDateToBR} from "../../../../../utils/time";
import {SETableColumnsProps} from "../../../../components/SETable";
import {Grid, IconButton} from "@mui/material";
import {RiCheckboxCircleFill, RiCloseCircleFill, RiDeleteBin6Line, RiPencilLine,} from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import {truncateString} from "../../../../../utils/utils";

const opcoesServicos: Record<string, string> = {
    'NA_PALMA_DA_MAO': 'App Sebrae',
    'NA_PALMA_ADM': 'Admin'
}

interface TableColumnsProps {
    handleEdit?: (data?: any) => void;
    handleCopy?: (data?: any) => void;
    handleUpdateStatus?: (data?: any) => void;
    handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
                                 handleEdit = () => {
                                 },
                                 handleDelete = () => {
                                 },
                                 handleUpdateStatus = () => {
                                 },
                             }: TableColumnsProps): SETableColumnsProps[] => [
    {
        id: 'dataCriacao',
        label: 'Data',
        customField: formatDateToBR,
    },
    {
        id: "criadoPor",
        label: "Responsável",
        align: "left",
        customField: (criadoPor) => criadoPor?.nome,
        minWidth: 10
    },
    {
        id: "servico",
        label: "Serviço",
        customField: (servico) => opcoesServicos[servico],
        align: "left",
    },
    {
        id: "diario",
        label: "Diário",
        customField: (diario) => diario ? 'Sim' : 'Não',
        align: "left",
    },

    {
        id: "motivo",
        label: "Motivo",
        align: "left",
        customField: (descricao) => (
            <div title={descricao}>
                { truncateString(descricao, 40) }
            </div>
        ),
    },
    {
        id: "descricao",
        label: "Descrição",
        align: "left",
        columnStyle: {
            overflowWrap: 'break-word',
            width: 300,
            wordBreak: 'break-word',
            whiteSpace: 'break-spaces'
        },
        customField: (descricao) => (
            <div title={descricao}>
                { truncateString(descricao, 40) }
            </div>
        ),
    },
    {
        id: "horaInicio",
        label: "Hora Início",
        align: "left",
    },
    {
        id: "horaFim",
        label: "Hora Fim",
        align: "left",
    },
    {
        id: "manutencao",
        label: "Status",
        align: "center",
        sortable: false,
        width: 320,
        customField: (value: any, row: any) => (
            <Grid container justifyContent="center" alignItems="center">
                <Grid item md={6} container alignItems="center" justifyContent="center">
                    <IconButton onClick={() => handleUpdateStatus(row)}>
                        <>
                            {!!value ?
                                ( <RiCheckboxCircleFill size={26} color="#66BD91" title={'Aprovado'}/> ) :
                                ( <RiCloseCircleFill size={26} color="#FF0000" title={'Reprovado'}/> )
                            }
                        </>
                    </IconButton>
                    <SETableIconButton onClick={() => handleEdit(row)}>
                        <RiPencilLine size={20} color="#555770"/>
                    </SETableIconButton>
                    <SETableIconButton onClick={() => handleDelete(row.id)}>
                        <RiDeleteBin6Line size={20} color="#555770"/>
                    </SETableIconButton>
                </Grid>
            </Grid>
        ),
    },
];
